export default __webpack_public_path__ + "static/media/dt4.3ae69ad2.webp";